<template lang="pug">
  .component.component-backoffice-client-type(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              VatButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .label(slot="n1") ID
          .field-value(slot="n1") V{{item.id}}
          .label(slot="n2") Name
          .field-value(slot="n2") {{item.description}} ({{item.name}})
          .label(slot="n3") Percentage
          .field-value(slot="n3") {{item.percentage}}%

</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
  import ClientTypeButtons from '../structure/ui/actions/ClientTypeButtons'
  import VatButtons from '../structure/ui/actions/VatButtons';

  export default {
    name: 'Vat',
    components: {
      VatButtons,
      ClientTypeButtons,
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Vat.vue?47426909